import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip'
import { cn } from '@/lib/utils'

interface ColorBadgeProps {
  color: string
  colorHex: string | null
  className?: string
  withoutTooltip?: boolean
  withoutCaption?: boolean
}

export const ColorBadge = ({
  color,
  className,
  colorHex,
  withoutTooltip = false,
  withoutCaption = false
}: ColorBadgeProps) => {
  if (!color) return '-'

  if (withoutTooltip) {
    return (
      <div className={cn('flex items-center gap-1.5', className)}>
        <div
          className='border-grey-400 size-3 shrink-0 rounded-full border'
          style={{
            backgroundColor: colorHex ?? ''
          }}
        />
        <div className='truncate text-xs !leading-none'>{color}</div>
      </div>
    )
  }

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <div className={cn('flex items-center gap-1.5', className)}>
          <div
            className='border-grey-400 size-3 shrink-0 rounded-full border'
            style={{
              backgroundColor: colorHex ?? ''
            }}
          />
          {withoutCaption ? null : <div className='truncate text-[10px] !leading-none'>{color}</div>}
        </div>
      </TooltipTrigger>
      <TooltipContent asChild>
        <div className={cn('flex items-center gap-1.5', className)}>
          <div
            className='border-grey-400 size-3 shrink-0 rounded-full border'
            style={{
              backgroundColor: colorHex ?? ''
            }}
          />
          <div className='text-[10px] !leading-none'>{color}</div>
        </div>
      </TooltipContent>
    </Tooltip>
  )
}
